import type { AccountInfo, Configuration } from '@azure/msal-browser';
import type { IMsalInstance } from '@/authSetup.ts';
import {
  selectAccountAndTryToAcquireTokenFunction,
  silentRequest,
} from '@/lib/selectAccountAndTryToAcquireToken';
import { loggedInUser, users } from './EntraUsers';
import { MockPublicClientApplication } from './msal';

export const msalFactory = (config: Configuration) => {
  // Use MSAL's default browser navigation in dev/e2e.
  // A custom NavigationClient is only allowed/used in unit tests.
  return new MockMsalInstance(loggedInUser, null, users, config);
};

export class MockMsalInstance
  extends MockPublicClientApplication
  implements IMsalInstance
{
  public readonly selectAccountAndTryToAcquireToken = () => {
    return selectAccountAndTryToAcquireTokenFunction(this);
  };

  async getAuthenticatedUser(): Promise<{
    account: AccountInfo;
    scopes: Array<string>;
  } | null> {
    const activeAccount = this.getActiveAccount();
    if (!activeAccount) return null;

    const result = await this.acquireTokenSilent(
      silentRequest(activeAccount),
    ).catch(() => null);

    if (result === null) return null;

    return {
      account: result.account,
      scopes: result.scopes,
    };
  }
}
